import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';;
import { UserService } from 'src/app/services/user.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { CareerService } from 'src/app/services/career.service';
import { OpponentsService } from 'src/app/services/opponents.service';
import { TournamentsService } from 'src/app/services/tournamnet.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-player-certificate',
  templateUrl: './player-certificate.component.html',
  styleUrls: ['./player-certificate.component.scss'],
  providers: [ConfirmationService, MessageService]
})

export class PlayerCertificateComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  countdown: number = 10;
  countdownInProgress: boolean = false;
  username: string;
  userName;
  public item;
  public profileDetails;
  public loggedInUser;
  public userId;
  public isLoggedIn: boolean = false;
  WithdrawcnfModal: boolean = false;
  thankwithdraw: boolean = false;
  public data: any;
  public careerDetails;
  public highestSkillJumpDetails;
  public options = {
    title: {
      display: true,
      text: 'My Title',
      fontSize: 16
    },
    legend: {
      position: 'bottom'
    }
  }
  wid: any;
  tname: any;
  mtn: any;
  thankwithdrawinfo: boolean = false;
  agn: any;
  matchTypes = environment.matchTypes;
  public opponentList: any = [];
  public tournamentList: any = [];
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  rankData: any;
  skillsData: any;
  basicOptions: any;
  public paginationOption = environment.pagination;
  public matchList: any = [];
  private lazyLoadEvent: LazyLoadEvent;
  public downloadFlg: boolean = false;
  public loading: boolean = false;
  public totalRecords: Number = 0;
  public startDate: Date;
  public endDate: Date;
  public errorMessage;
  public id;
  public searchby;
  constructor(
    private tokenStorage: TokenStorageService,
    private route: ActivatedRoute,
    private userService: UserService,
    private careerService: CareerService,
    private opponentsService: OpponentsService,
    private tournamentsService: TournamentsService,
  ) {

  }
  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get("id");

    this.loggedInUser = this.tokenStorage.getUser();
    this.userId = this.loggedInUser.userdata.id;
    // if (this.loggedInUser.userdata != undefined) {
    //   this.isLoggedIn = true;
    //   this.userId = this.loggedInUser.userdata.id;
    // }
    // if (this.isLoggedIn == false) {
    //   this.router.navigate(['/']);
    // }

    //this.getMyTournamentList(this.lazyLoadEvent);
    this.getUserDetails(this.id);
  }

  getMyTournamentList(event: LazyLoadEvent) {
    //console.log(event);
    this.lazyLoadEvent = event;
    var query = "?filterByDisabled=false&filterByUserId=" + this.id;
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = (event.first / event.rows) + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }

    if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
      //console.log(params);
    }

    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    /**
    * Sequence wise sort.
    **/
    // else {
    //     query += "&sortBy=getSequencewise" + "&orderBy=desc";
    // }
    this.tournamentsService.getPlayerAcheivement(query).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        //console.log(data);
        this.loading = false;
        this.matchList = [];
        this.matchList = data.data.items;

        this.totalRecords = data.data.totalCount;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  getUserDetails(userId) {
    this.userService.getUserDetails(userId).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.item = data;
        if (this.item) {
          this.profileDetails = this.item;
          this.userName = this.profileDetails.fullName;
        }
      }, err => {

      });

  }

  getCareerDetails() {
    this.careerService.getCareerDetails().then(
      data => {

        this.careerDetails = data[0];

      }, err => {

      });
  }

  getOpponentsList() {
    this.opponentsService.getOpponentsList().then(
      data => {
        this.opponentList = data;


      }, err => {

      }
    )
  }
  getHighestSkillJumpData() {
    this.careerService.getHighestSkillJumpDetails().then(
      data => {

        this.highestSkillJumpDetails = data;

      }, err => {

      });
  }

  getTournamentsList() {
    this.tournamentsService.getTournamentsList().then(
      data => {
        this.tournamentList = data;

      }, err => {

      });
  }
  startCountdown(): void {
    this.countdownInProgress = true;
    const interval = setInterval(() => {
      this.countdown--;
      if (this.countdown === 0) {
        clearInterval(interval);
        this.countdownInProgress = false;
      }
    }, 1000);
  }

  resetCountdown(): void {
    this.countdown = 10;
    this.countdownInProgress = false;
  }

  // withdrawModal(){
  //   this.WithdrawcnfModal = true;
  // }
  withdrawModal(wid, tname, mtn, agn) {
    this.WithdrawcnfModal = true;
    this.wid = wid;
    this.tname = tname;
    this.mtn = mtn;
    this.agn = agn;
  }
  // thankyouwithdraw(){
  //   this.thankwithdraw = true;
  //   this.WithdrawcnfModal = false;
  // }
  thankyouwithdraw() {

    this.WithdrawcnfModal = false;
    const wbody = {
      disable: true,
      playerId: this.id
    };
    this.tournamentsService.getwithdrawamount(this.wid, wbody).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.wid = "";
        this.tname = "";
        this.mtn = "";
        this.agn = "";
        //console.log("Updated Tournament Player:", res);
        this.thankwithdrawinfo = true;
        this.countdownInProgress = true;
        const interval = setInterval(() => {
          this.countdown--;
          if (this.countdown === 0) {
            clearInterval(interval);
            this.countdownInProgress = false;
            window.location.reload();
          }
        }, 1000);
        // this.thankwithdraw = true;
        // setTimeout(() => {
        //   window.location.reload();
        // }, 6000);
      },
      (error) => {
        // Handle error (e.g., show an error message)
        console.error('Error updating tournament player:', error);
      }
    );
  }

  downloadPdf(certificatePic) {
    window.open(certificatePic);
  }

   ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


}
